{
  "Automatic ({language})": "自動（{language}）",
  "Language": "言語",
  "Cancel": "キャンセル",
  "OK": "OK",
  "Ok": "OK",
  "Okay": "OK",
  "Yes": "はい",
  "No": "いいえ",
  "Save": "保存",
  "Saved": "保存しました",
  "Saving...": "保存中...",
  "Saving…": "保存中…",
  "Delete": "削除",
  "Remove": "削除",
  "Edit": "編集",
  "Change": "変更",
  "Close": "閉じる",
  "Done": "完了",
  "Back": "戻る",
  "Next": "次へ",
  "Continue": "続ける",
  "Skip": "スキップ",
  "Retry": "再試行",
  "Try again": "もう一度試す",
  "Please try again.": "もう一度お試しください。",
  "Please try again": "もう一度お試しください",
  "Something went wrong": "問題が発生しました",
  "Something went wrong. Please try again.": "問題が発生しました。もう一度お試しください。",
  "Error": "エラー",
  "Loading...": "読み込み中...",
  "Loading…": "読み込み中…",
  "Share": "共有",
  "Copy": "コピー",
  "Copy link": "リンクをコピー",
  "Copied": "コピーしました",
  "Copied!": "コピーしました！",
  "Link copied": "リンクをコピーしました",
  "Open": "開く",
  "Restore": "復元",
  "Learn more": "詳しく見る",
  "More": "その他",
  "Help": "ヘルプ",
  "Settings": "設定",
  "Open Settings": "設定を開く",
  "Profile": "プロフィール",
  "Email": "メールアドレス",
  "Password": "パスワード",
  "Name": "名前",
  "Title": "タイトル",
  "Location": "場所",
  "Date and time": "日時",
  "Privacy": "プライバシー",
  "Embed": "埋め込み",
  "Branding": "ブランディング",
  "Logo": "ロゴ",
  "Guestbook": "ゲストブック",
  "Fundraising": "募金",
  "Pricing": "料金",
  "Plans": "プラン",
  "EventLive Plans": "EventLiveのプラン",
  "My Events": "マイイベント",
  "Event link": "イベントリンク",
  "Event title": "イベント名",
  "Go Live": "ライブ配信を開始",
  "Watch Live": "ライブ配信を視聴",
  "Live only": "ライブ配信のみ",
  "Start free test": "無料テストを開始",
  "Free test": "無料テスト",
  "Unlock event": "イベントをアンロック",
  "Unlock": "アンロック",
  "Sell Tickets": "チケットを販売",
  "Video Wall": "ビデオウォール",
  "Manage Video": "動画を管理",
  "Upload video": "動画をアップロード",
  "What's new": "新機能",
  "What's New": "新機能",
  "Camera": "カメラ",
  "Required": "必須",
  "Terms": "利用規約",
  "Monthly": "月額",
  "Unlimited": "無制限",
  "Not found": "見つかりません",
  "Not signed in": "ログインしていません",
  "Please sign in again.": "もう一度ログインしてください。",
  "Too many requests. Please wait a moment and try again.": "リクエストが多すぎます。しばらく待ってから、もう一度お試しください。",
  "Welcome to EventLive": "EventLiveへようこそ",
  "Today": "今日",
  "Tomorrow": "明日",
  "Yesterday": "昨日",
  "MMM D, YYYY": "YYYY年M月D日",
  "MMM D": "M月D日",
  "h:mm A": "H:mm",
  "h:mm a": "H:mm",
  "Test Event": "テストイベント"
}
